import { Injectable } from '@angular/core';
import { ApiClient } from '../core/api-client.service';
import { Observable } from 'rxjs';
import { GetPendingNewsListRequest } from './DTOs/get-pending-news-list-request';
import { PendingNewsDtRetInfo } from './DTOs/pending-news-dt-ret-info';
import { PendingNewsInfo } from './DTOs/pending-news-info';
import { VerifyRejectRequest } from '../core/verify-reject-request';
import { UpdatePendingNewsRequest } from './DTOs/update-pending-news-request';

@Injectable({
    providedIn: 'root'
})

export class PendingNewsService {
    readonly relativeBase = "pending-news/";

    constructor(private http: ApiClient) { }

    getPendingNewsList(request: GetPendingNewsListRequest): Observable<PendingNewsDtRetInfo> {
        return this.http.post(this.relativeBase + "get-pending-news", request);
    }

    getPendingNewsInfo(id: number): Observable<PendingNewsInfo> {
        return this.http.get(this.relativeBase + "get-pending-news-details/" + id);
    }
    changeNewsStatus(request: VerifyRejectRequest, status: number) {
        if(status == 1)
            return this.http.post(this.relativeBase + "approve", request);
        else
            return this.http.post(this.relativeBase + "reject", request);
    }
    updateNews(request: UpdatePendingNewsRequest) {
        return this.http.post(this.relativeBase + "update", request);
    }
    uploadNewImage(formData: FormData) {
        return this.http.post(this.relativeBase + "upload", formData);
    }
}
